import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';

import { SmallSectionHeader, Captions } from 'components/Typography';
import { Info } from 'react-feather';

const StyledCaptions = styled(Captions)`
  && {
    margin-bottom: 0;
  }
`;
const StyledIconInfo = styled(Info)`
  && {
    cursor: pointer;
  }
`;

const ItemResult = (props: {
  title: string;
  subTitle: string;
  onClick?: any;
}) => {
  return (
    <Box pr={3} py={2.5} onClick={props.onClick}>
      <Grid container>
        <Grid item xs={11}>
          <SmallSectionHeader color="#3461C5" weight="500">
            {props.title}
          </SmallSectionHeader>
          <StyledCaptions weight="400">{props.subTitle}</StyledCaptions>
        </Grid>
        <Grid container alignContent="center" justify="flex-end" item xs={1}>
          <StyledIconInfo color={'#424B5A'} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ItemResult;
